import { render, staticRenderFns } from "./adjust_table.vue?vue&type=template&id=a0cd34c6&scoped=true"
import script from "./adjust_table.vue?vue&type=script&lang=js"
export * from "./adjust_table.vue?vue&type=script&lang=js"
import style0 from "./adjust_table.vue?vue&type=style&index=0&id=a0cd34c6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cd34c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0cd34c6')) {
      api.createRecord('a0cd34c6', component.options)
    } else {
      api.reload('a0cd34c6', component.options)
    }
    module.hot.accept("./adjust_table.vue?vue&type=template&id=a0cd34c6&scoped=true", function () {
      api.rerender('a0cd34c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/record_manage/discount_cost_pool/form/components/adjust_table.vue"
export default component.exports